module.exports = __webpack_public_path__ + "img/banner.856ab04e.svg";